import { DefaultDetailContext } from 'src/app/controls/forms/default-detail-context';
import { ICustomer } from 'src/app/models/interfaces/customer.interface';

export class CustomerDetailContext extends DefaultDetailContext<ICustomer, number> {}
